import {Pipe, PipeTransform} from '@angular/core';
import {Role} from './user';

@Pipe({
    name: 'zahRolIcon',
    standalone: false
})
export class RolIconPipe implements PipeTransform {
  transform(role: Role): string {
    if (role === Role.THUISVERZORGER) {
      return 'person';
    } else if (role === Role.REGIOVERANTWOORDELIJKE) {
      return 'groups';
    } else if (role === Role.THERAPEUT) {
      return 'supervisor_account';
    } else if (role === Role.ADMIN) {
      return 'person';
    }
  }
}
